module.exports = __webpack_public_path__ + "static/media/house.5583d995.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/house.svg
// module id = 1995
// module chunks = 33